module.exports = __webpack_public_path__ + "img/w70.bf51c58f.svg";